import { apiWithoutAuthentication } from '@/services/api';

const AccountScenario = {
  sendPasswordResetMail: email => {
    return apiWithoutAuthentication.post('send_password_reset_mail/', {
      email: email
    });
  },
  validatePasswordResetToken: (email, token) => {
    return apiWithoutAuthentication.get('validate_password_reset_token/', {
      params: {
        email: email,
        token: token
      }
    });
  },
  passwordReset: (uid, email, newPassword) => {
    return apiWithoutAuthentication.post('password_reset/', {
      uid: uid,
      email: email,
      newPassword: newPassword
    });
  }
};

export default AccountScenario;



// WEBPACK FOOTER //
// ./src/api/account/scenario.js